<template>
  <Row :gutter="gutter">
    <Col span="12">
      <Select :label-in-value="true" :placeholder="leftPlaceholder" @on-change="classifyChange" clearable
              v-model="objData.classId">
        <Option :key="item.value" :value="item.id" v-for="item in classifyDatas">
          {{ item.name }}
        </Option>
      </Select>
    </Col>
    <Col span="12">
      <Select :label-in-value="true" :placeholder="rightPlaceholder" @on-change="groupChange" clearable
              v-model="objData.groupId">
        <Option :key="item.value" :value="item.id" v-for="item in groupDatas">{{ item.name }}</Option>
      </Select>
    </Col>
  </Row>
</template>

<script>
import {mapActions} from 'vuex'
import Bus from '../../utils/bus'

export default {
  name: 'ClassChooseWidget',
  props: {
    leftPlaceholder: {
      type: String,
      default: '全部分类'
    },
    rightPlaceholder: {
      type: String,
      default: '全部分组'
    },
    gutter: {
      type: Number,
      default: 15
    },
    srcType: {
      type: Number,
      default: 11
    },
    objData: {
      type: Object,
      default: () => {
        return {
          classId: 0,
          groupId: 0
        }
      }
    }
  },
  data () {
    return {
      classifyDatas: [],
      groupDatas: [],
      fun: null
    }
  },
  watch: {
    'objData.classId': {
      handler (newValue) {
        if (this.objData.classId > 0) {
          this.getGroupListDatas(this.objData.classId).then(() => {
          })
        } else {
          this.groupDatas = []
        }
        this.objData.groupId = 0
      }
    }
  },
  mounted () {
    this.init()
  },
  destroyed () {
    Bus.$off('cgChange', this.fun)
  },
  methods: {
    async init () {
      this.classifyDatas = await this.getClassList()
      this.fun = async (e) => {
        if (parseInt(e.type) === this.srcType) {
          if (e.changeType === 11 || e.changeType === 12 || e.changeType === 13) {
            this.classifyDatas = await this.getClassList()
            if (e.changeType === 13 && this.objData.classId === e.changeId) {
              // if (this.classifyDatas && this.classifyDatas.length) {
              //   this.objData.classId = this.classifyDatas[0].id || 0
              // } else {
              this.objData.classId = 0
              // }
            }
          } else if (e.changeType === 21 || e.changeType === 22 || e.changeType === 23) {
            if (this.objData.classId > 0) {
              await this.getGroupListDatas(this.objData.classId)
              if (e.changeType === 23 && this.objData.groupId === e.changeId) {
                this.objData.groupId = 0
              }
            }
          }
        }
      }
      Bus.$on('cgChange', this.fun)
    },
    getClassList () {
      return new Promise((resolve, reject) => {
        let params = {
          type: this.srcType,
        }
        this.getCategoryLists(params).then((res) => {
          if (res.code === 0) {
            let arr = res.data
            resolve(arr)
          }
        })
      })
    },
    getGroupListDatas (pid) {
      return new Promise((resolve, reject) => {
        let params = {
          categoryId: pid,
          type: this.srcType
        }
        this.getGroupLists(params).then(res => {
          this.groupDatas = res.data
          resolve()
        })
      })
    },
    emitData: function () {
      let objChange = JSON.parse(JSON.stringify(this.objData))
      if (objChange.classId) {
        let list = this.classifyDatas.filter(res => {
          return res.id === objChange.classId
        })
        if (list && list.length) {
          objChange.linkurl = list[0].link ? list[0].link.link || '' : ''
        }
      }

      if (objChange.groupId) {
        let glist = this.groupDatas.filter(res => {
          return res.id === objChange.groupId
        })

        if (glist && glist.length) {
          objChange.linkurl = glist[0].link ? glist[0].link.link || '' : ''
        }
      }
      console.log('objChange.linkurl', objChange.linkurl)
      this.$emit('dataChange', objChange)
    },
    classifyChange () {
      this.$nextTick(() => {
        this.emitData()
      })

    },
    groupChange () {
      this.$nextTick(() => {
        this.emitData()
      })
    },
    ...mapActions([
      'getCategoryLists',
      'getGroupLists'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>
